import fetchRequest from '../../helpers/fetchRequest';

export async function getAudioStreams() {
  const api = '/streams/audio-list';
  const options = {
    method: 'GET',
  };
  return fetchRequest(api, options);
}

export async function getSocialLinks() {
  const url = '/active-slides/socials';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getSongPicture(artist, song) {
  const url = '/streams/get-song-pic';
  const options = {
    method: 'POST',
    body: JSON.stringify({"artist": artist, "song": song}),
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}
